import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import AuthModule from './modules/auth';
import SearchModule from './modules/search';
import ProjectFormModule from './modules/projects/form';
import TasksFormModule from './modules/projects/taskform';
import InformationModule from './modules/information';
import OvertimeModule from './modules/overtime';
import NotificationsModule from './modules/notifications';
import ProjectModule from './modules/projects';
import HrUsersModule from './modules/hr/users';
import HrUsergroupsModule from './modules/hr/usergroups';
import HrTeamsModule from './modules/hr/teams';
import MypagesMeModule from './modules/mypages/me';
import MypagesNotificationsModule from './modules/mypages/notifications';
import SupportModule from './modules/support/index';

// CRM
import CrmCompanyModule from './modules/crm/company';
import CrmContactModule from './modules/crm/contact';
import CrmGroupsModule from './modules/crm/groups';

// Settings
import SettingsModule from './modules/settings/settings';
import SettingsImagesizesModule from './modules/settings/imagesizes';
import SettingsCostcodesModule from './modules/settings/costcodes';
import SettingsCountersModule from './modules/settings/counters';
import SettingsTemplatesModule from './modules/settings/templates';

// Shared stores
import SharedCountries from './shared/countries';

// Ziggy
import route from 'ziggy';
import { Ziggy } from '../ziggy';

// Load vuex in vue
Vue.use(Vuex);

// Pending request to the data endpoint
let dataRequest = null;

// Default states
const state = {
    counters:{},
    dataisloading:false,
    dataloaded:false,
    grids:{},
    loading:true,
    moneysettings: {
        decimal: ',',
        thousands: '.',
        prefix: '€ ',
        suffix: '',
        precision: 2,
        masked: false
    },
    officeusers:[],
    routes:{},
    hasSubMenu: false,
};

// Getters
const getters = {
    dataLoaded: state => state.dataloaded,
    getCounters: state => state.counters,
    getGrids: state => state.grids,
    getMoneySettings: state => state.moneysettings,
    getOfficeUsers: state => state.officeusers,
    getRoutes: state => state.routes,
    isLoading: state => state.loading,
    hasSubMenu: state => state.hasSubMenu,
};

// Actions
const actions = {
    parseData: (store) => {
        if (state.dataloaded === true) {
            return Promise.resolve();
        }
        // Share the pending request so every caller can wait until the data is available
        if (dataRequest !== null) {
            return dataRequest;
        }
        store.commit("DATAISLOADING", true);
        dataRequest = axios.get(route('api.v1.data', [], true, Ziggy))
        .then(response => {
            // Check response
            if (response.data.success) {
                store.commit("COUNTERS_SET",response.data.data.counters);
                store.commit("GRIDS_SET",response.data.data.grids);
                store.commit("ROUTES_SET",response.data.data.routes);
                store.commit("OFFICEUSERS_SET", response.data.data.office);
                // This commit needs to be last
                store.commit("DATA_LOADED", true);
            } else {
                console.debug("Error response received from data endpoint!");
            }
        })
        .catch(() => {
            console.debug("Error while loading the data endpoint!");
        })
        .finally(() => {
            store.commit("DATAISLOADING", false);
            if (state.dataloaded !== true) {
                dataRequest = null;
            }
        });
        return dataRequest;
    },
    setCounters: (store, payload) => store.commit("COUNTERS_SET",payload),
    setGrids: (store, payload) => store.commit("GRIDS_SET",payload),
    setLoading: (store, payload) => store.commit("LOADING_SET", payload),
    setRoutes: (store, payload) => store.commit("ROUTES_SET",payload),
    setHasSubMenu: (store, payload) => store.commit("HAS_SUB_MENU_SET",payload),
};

// Mutators
const mutations = {
    COUNTERS_SET: (state, payload) => state.counters = payload,
    DATA_LOADED: (state) => state.dataloaded = true,
    DATAISLOADING: (state, payload) => state.dataisloading = payload,
    GRIDS_SET: (state, payload) => state.grids = payload,
    LOADING_SET: (state, payload) => state.loading = payload,
    OFFICEUSERS_SET: (state, payload) => state.officeusers = payload,
    ROUTES_SET: (state, payload) => state.routes = payload,
    HAS_SUB_MENU_SET: (state, payload) => state.hasSubMenu = payload,
};

// Create the actual store
const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    getters,
    actions,
    mutations,
    modules: {
        AuthModule,
        SearchModule,
        ProjectFormModule,
        TasksFormModule,
        InformationModule,
        OvertimeModule,
        NotificationsModule,
        ProjectModule,
        // Mypages
        MypagesMeModule,
        MypagesNotificationsModule,
        // HR
        HrUsersModule,
        HrUsergroupsModule,
        HrTeamsModule,
        // CRM
        CrmCompanyModule,
        CrmContactModule,
        CrmGroupsModule,
        // Settings
        SettingsModule,
        SettingsImagesizesModule,
        SettingsCostcodesModule,
        SettingsCountersModule,
        SettingsTemplatesModule,
        // Support
        SupportModule,

        // Shared
        SharedCountries,
    }
});

// Export it.
export default store;
